import React from "react";
import "./loader.css";

export const PlaybackLoader = ({ height = "100%" }) => {
    return (
        <div className="playback-loader-wrapper" style={{ height }}>
            <div role="status" aria-label="Loading...">
                <svg width="80" height="20" viewBox="0 0 80 20">
                    <circle className="playback-circle" cx="15" cy="10" r="6" />
                    <circle className="playback-circle" cx="40" cy="10" r="6" style={{ animationDelay: "0.2s" }} />
                    <circle className="playback-circle" cx="65" cy="10" r="6" style={{ animationDelay: "0.4s" }} />
                </svg>
            </div>
        </div>
    );
};